var map = {
	"./ar/label.json": "./src/locale/ar/label.json",
	"./cy/label.json": "./src/locale/cy/label.json",
	"./cz/label.json": "./src/locale/cz/label.json",
	"./da/label.json": "./src/locale/da/label.json",
	"./de/label.json": "./src/locale/de/label.json",
	"./en/label.json": "./src/locale/en/label.json",
	"./es/label.json": "./src/locale/es/label.json",
	"./fi/label.json": "./src/locale/fi/label.json",
	"./fr/label.json": "./src/locale/fr/label.json",
	"./hu/label.json": "./src/locale/hu/label.json",
	"./it/label.json": "./src/locale/it/label.json",
	"./ja/label.json": "./src/locale/ja/label.json",
	"./ko/label.json": "./src/locale/ko/label.json",
	"./kz/label.json": "./src/locale/kz/label.json",
	"./nl/label.json": "./src/locale/nl/label.json",
	"./pl/label.json": "./src/locale/pl/label.json",
	"./pt/label.json": "./src/locale/pt/label.json",
	"./ro/label.json": "./src/locale/ro/label.json",
	"./ru/label.json": "./src/locale/ru/label.json",
	"./sk/label.json": "./src/locale/sk/label.json",
	"./sv/label.json": "./src/locale/sv/label.json",
	"./vn/label.json": "./src/locale/vn/label.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locale sync recursive ^\\.\\/.*\\/label\\.json$";